import { IRechnungsposition } from '../../../models/ApiTypes';
import * as React from 'react';
import { observer } from 'mobx-react';
import { FormGroup, FormControl } from 'react-bootstrap';

import { bind } from '../../../utils/decorators';

interface IRechnungspositionProps {
  position: IRechnungsposition;
  anzahl: number;
  preiseAnzeigen: boolean;
  setAnzahlHandler: (anzahl: number, position: IRechnungsposition) => void;
}

/** Komponente zur Anzeige einer einzelnen Rechnungsposition inkl. Auswahl der Anzahl und Vorschau des Gesamtpreises */
@observer
export default class Rechnungsposition extends React.Component<IRechnungspositionProps, {}> {

  @bind handleValueChanged(event: React.FormEvent<FormControl>) {
    const anzahl = parseInt((event.target as HTMLInputElement).value, 10);
    this.props.setAnzahlHandler(anzahl, this.props.position);
  }

  render() {
    const { bezeichnung, preis } = this.props.position;
    return (
      <tr>
        <td width="75%">{`${bezeichnung}`}</td>
        <td width="10%">
          <FormGroup>
            <FormControl
              className="text-right"
              onChange={this.handleValueChanged}
              type="number"
              min="0"
              step="1"
              value={this.props.anzahl}
            />
          </FormGroup>
        </td>
        {this.props.preiseAnzeigen &&
          <td width="15%" className="text-right">
            {preis.toFixed(2).replace('.', ',')} €
          </td>
        }
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/abrechnung/Rechnungsposition.tsx